import { render, staticRenderFns } from "./Emoticon.vue?vue&type=template&id=3e7e839f&scoped=true&"
import script from "./Emoticon.vue?vue&type=script&lang=js&"
export * from "./Emoticon.vue?vue&type=script&lang=js&"
import style0 from "./Emoticon.vue?vue&type=style&index=0&id=3e7e839f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7e839f",
  null
  
)

export default component.exports